import { render, staticRenderFns } from "./PriceTariffSearch.vue?vue&type=template&id=511850c8"
import script from "./PriceTariffSearch.vue?vue&type=script&lang=js"
export * from "./PriceTariffSearch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports